var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatistic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 20V2h2v18c0 .55.44 1 1 1h18v2H4c-1.66 0-3-1.35-3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3c0-.56.44-1 1-1h5c.55 0 1 .44 1 1v16c0 .55-.45 1-1 1h-5c-.56 0-1-.45-1-1V3Zm2 1v14h3V4h-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 7c0-.56.44-1 1-1h5c.55 0 1 .44 1 1v12c0 .55-.45 1-1 1h-5c-.56 0-1-.45-1-1V7Zm2 1v10h3V8h-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12c0-.56.44-1 1-1h5c.55 0 1 .44 1 1v7c0 .55-.45 1-1 1H5c-.56 0-1-.45-1-1v-7Zm2 1v5h3v-5H6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistic);
export default __webpack_public_path__ + "static/media/statistic.8fa54fe90b360a6e85a0480149478d1f.svg";
export { ForwardRef as ReactComponent };